import { ThemeProvider as MaterialThemeProvider } from '@mui/material/styles';
import React, { FC, PropsWithChildren } from 'react';

import theme from '../../theme';

const ThemeProvider: FC<PropsWithChildren> = ({ children }) => (
  <MaterialThemeProvider theme={theme}>{children}</MaterialThemeProvider>
);

export default ThemeProvider;
